import { createReducer } from 'utils/helpers';
import { ProductReceiptsActionTypes, IActions } from './ProductReceipts.actions';
import { IPriceOverrideAuthorityDialogProperties } from 'components/common/PriceOverrideAuthorityDialog/PriceOverrideAuthorityDialog.properties';
import { IProductReceiptContextPageFacade } from 'api/swaggerTypes';

export type IPriceOverrideDialogState<IApiType = any> = Omit<IPriceOverrideAuthorityDialogProperties<IApiType>, 'values' | 'resetForm' | 'onOk' | 'onCancel'>;
export interface IState {
    ProductReceiptContext?: IProductReceiptContextPageFacade;
    ProductReceiptsLookupPanelOpen?: boolean;
    ProductReceipt?: number;
    LineNumber?: number;
    SummaryPanelData?: any;
    IsChangeStatusDisabled: boolean;
    PreventChangeStatus: boolean;
    LHSFocusField: string;
}

export const initialState: IState = {
    ProductReceiptContext: {},
    ProductReceiptsLookupPanelOpen: true,
    ProductReceipt: undefined,
    LineNumber: 0,
    SummaryPanelData: undefined,
    IsChangeStatusDisabled: false,
    PreventChangeStatus: false,
    LHSFocusField: 'Warehouse'
};

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<ProductReceiptsActionTypes, IAction>;

const actionMap: IActionMap = {
    [ProductReceiptsActionTypes.setProductReceiptContext]: (state: IState, payload: IState['ProductReceiptContext']): IState => ({ ...state, ProductReceiptContext: payload }),
    [ProductReceiptsActionTypes.setProductReceipt]: (state: IState, payload: IState['ProductReceipt']): IState => ({ ...state, ProductReceipt: payload }),
    [ProductReceiptsActionTypes.setLineNumber]: (state: IState, payload: IState['LineNumber']): IState => ({ ...state, LineNumber: payload }),
    [ProductReceiptsActionTypes.setSummaryPanelData]: (state: IState, payload: IState['SummaryPanelData']): IState => ({ ...state, SummaryPanelData: payload }),
    [ProductReceiptsActionTypes.setIsChangeStatusDisabled]: (state: IState, payload: IState['IsChangeStatusDisabled']): IState => ({ ...state, IsChangeStatusDisabled: payload }),
    [ProductReceiptsActionTypes.setPreventChangeStatus]: (state: IState, payload: IState['PreventChangeStatus']): IState => ({ ...state, PreventChangeStatus: payload }),
    [ProductReceiptsActionTypes.setProductReceiptsLookupPanelOpen]: (state: IState, payload: IState['ProductReceiptsLookupPanelOpen']): IState => ({ ...state, ProductReceiptsLookupPanelOpen: payload }),
    [ProductReceiptsActionTypes.setLHSFocusField]: (state: IState, payload: IState['LHSFocusField']): IState => ({ ...state, LHSFocusField: payload }),

};

export default createReducer<IActionMap, IState, IActions>(actionMap);
